"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_AUTH = exports.USER_AUTHS = void 0;
const __1 = require("..");
exports.USER_AUTHS = __1.ADMIN.child("/userAuths");
exports.USER_AUTH = exports.USER_AUTHS.sub("/:email");
